export const activePrescriptionCard_style ={
    rootSx:{
        paddingTop:"0px"
    }
}